import React, { useState } from 'react';
import { FiSearch, FiClock, FiCheckCircle, FiAlertCircle, FiTrash2 } from 'react-icons/fi';
import { Card, CardHeader, CardTitle, CardContent } from '../common/Card';

const EvaluationList = ({ evaluations, onSelect, onDelete, selectedEvaluationId }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // 过滤评估记录列表
  const filteredEvaluations = evaluations.filter(evaluation =>
    `${evaluation.jd_title}-${evaluation.candidate_name}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 获取状态图标
  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return <FiClock className="h-4 w-4 text-yellow-500" />;
      case 'completed':
        return <FiCheckCircle className="h-4 w-4 text-green-500" />;
      case 'failed':
        return <FiAlertCircle className="h-4 w-4 text-destructive" />;
      default:
        return null;
    }
  };

  return (
    <Card className="h-full">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-xl">评估记录</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="mb-4 relative">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="搜索评估记录..."
            className="w-full rounded-md border border-input bg-background pl-9 pr-3 py-2 text-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="space-y-2 max-h-[calc(100vh-280px)] overflow-y-auto pr-2">
          {filteredEvaluations.length > 0 ? (
            filteredEvaluations.map((evaluation) => (
              <div
                key={evaluation.id}
                className={`p-3 rounded-md border cursor-pointer transition-colors ${
                  selectedEvaluationId === evaluation.id
                    ? 'bg-primary/10 border-primary'
                    : 'hover:bg-accent'
                }`}
                onClick={() => onSelect(evaluation.id)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-medium truncate">
                    {evaluation.jd_title} - {evaluation.candidate_name}
                  </h3>
                  <div className="flex items-center gap-2">
                    {evaluation.status && getStatusIcon(evaluation.status)}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(evaluation.id);
                      }}
                      className="p-1 rounded-md hover:bg-destructive/10 hover:text-destructive"
                      aria-label="删除"
                    >
                      <FiTrash2 className="h-4 w-4" />
                    </button>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground mt-1">
                  创建于: {new Date(evaluation.created_at).toLocaleDateString()}
                </p>
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              {searchTerm ? '没有找到匹配的评估记录' : '暂无评估记录'}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default EvaluationList;
